<article class="indicador-card" [attr.aria-label]="label()">
  <p class="indicador-card-label">{{ label() }}</p>
  <div class="indicador-card-value-row">
    <p class="indicador-card-value" data-testid="indicador-value">{{ value() }}</p>
    @if (trend(); as trendDirection) {
      <span
        class="indicador-card-trend"
        [class.indicador-card-trend--up]="trendDirection === 'up'"
        [class.indicador-card-trend--down]="trendDirection === 'down'"
        [class.indicador-card-trend--neutral]="trendDirection === 'neutral'"
        [attr.aria-label]="trendLabel()"
        data-testid="indicador-trend"
      >
        @switch (trendDirection) {
          @case ('up') {
            &#9650;
          }
          @case ('down') {
            &#9660;
          }
          @default {
            &#9644;
          }
        }
      </span>
    }
  </div>
</article>
